<script lang="ts">
export default {
  name: 'LimitPremiumCounterToggle',
};
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { computed, inject } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { Book, BookOpen } from 'lucide-vue-next';

// ---------------
// reactive data
// ---------------
const store = inject<Store<AppState>>('store');

// ----------
// computed
// ----------
const limitPremiumCounterEnabled = computed<boolean | undefined>(() => {
  return store?.state.towerCanvasState.limitPremiumCounterEnabled;
});

// ----------
// handlers
// ----------
function handleToggleLimitPremiumCounter(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(
    StoreMutationType.SET_LIMIT_PREMIUM_COUNTER_MODE,
    !store?.state.towerCanvasState.limitPremiumCounterEnabled,
  );
}
</script>

<template>
  <div class="tw:self-end tw:py-2">
    <label title="Toggle Limit Premium Counter">
      <input
        type="checkbox"
        name="limit-premium-counter-toggle"
        aria-label="Limit Premium Counter Toggle"
        class="tw:pointer-events-none tw:box-border tw:hidden"
        @click="handleToggleLimitPremiumCounter"
      />
      <div
        class="tw:border-box tw:pointer-events-auto tw:flex tw:h-10 tw:w-10 tw:cursor-pointer tw:items-center tw:justify-center tw:rounded-lg tw:border tw:border-solid tw:border-(--tower-v2-border-color) tw:bg-(--tower-v2-tool-selected-color) tw:shadow-lg tw:hover:bg-[--tower-v2-hover-color]"
      >
        <BookOpen v-if="limitPremiumCounterEnabled" />
        <Book v-else />
      </div>
    </label>
  </div>
</template>
